import React from 'react';
import styled from 'styled-components';

const Image = styled.img``;

export default ({ image }) => {
  return <Image src={image.croppedSrc} />;
};
